module.exports = __webpack_public_path__ + "static/mission-vision-hero-img-297bcb4a03d9621ee0d5108d3e0f627e.png";